<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile" style="max-width: 100%;">
  <span i18n='Club section title@@tixxSelect.sectionHeading.receivedRequests' class="esf-action-heading__text">Received requests</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <app-spinner [name]="spinnerName" [autoRefresh]="true"></app-spinner>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1; max-width: 100%">
  <div class="esf-info-tile__content esf-primary-requests__info">
    <div class="center-text">
      <span class="large-text">{{ eventKpis?.primaryRequests.requests || '0' }}</span>
      <h5 i18n="@@lotteryDashboard.summaryTitle.requestsRecieved">Requests received</h5>
      <span>
        ({{ eventKpis?.primaryRequests.tickets || '0' }}
        <span i18n="@@lotteryDashboard.general.tickets">tickets</span>)
      </span>
    </div>
    <div class="vr"></div>
    <div class="center-text">
      <span class="esf-icon--success large-text">{{ eventKpis?.totalSeatedRequests || '0' }}</span>
      <h5 class="esf-icon--success"
          i18n="@@lotteryDashboard.summaryTitle.seated">Seated</h5>
      <span class="esf-icon--success">
        ({{ eventKpis?.totalSeatedTickets || '0' }}
        <span i18n="@@lotteryDashboard.general.tickets">tickets</span>)
      </span>
    </div>
    <div class="vr"></div>
    <div class="center-text">
      <span class="esf-icon--info large-text">{{ eventKpis?.primaryRequests.prioritizedRequests || '0' }}</span>
      <h5 class="esf-icon--info"
          i18n="@@lotteryDashboard.summaryTitle.prioritized">Prioritized</h5>
      <span class="esf-icon--info">
        ({{ eventKpis?.primaryRequests.prioritizedTickets || '0' }}
        <span i18n="@@lotteryDashboard.general.tickets">tickets</span>)
      </span>
    </div>
    <div class="vr"></div>
    <div class="center-text">
      <span class="esf-icon--alert large-text">{{ eventKpis?.primaryRequests.deferredRequests || '0' }}</span>
      <h5 class="esf-icon--alert"
          i18n="@@lotteryDashboard.summaryTitle.deferred">Deferred</h5>
      <span class="esf-icon--alert">
        ({{ eventKpis?.primaryRequests.deferredTickets || '0' }}
        <span i18n="@@lotteryDashboard.general.tickets">tickets</span>)
      </span>
    </div>
  </div>
</div>
